/*
* Broadcast Theme - Custom JS
* Quick View Modal fix: Kitenzo app overrides CSS via inline styles,
* so we use MutationObserver + element.style.setProperty('important') to win.
*
* Strategy:
* - Overlay: position:fixed fullscreen, display:flex, center children
* - Any wrappers between overlay and content: display:contents (invisible to layout)
* - Content: position:static, flows as direct flex child of overlay
* - Mobile: content goes full-screen
*/

(function() {
  var isMobile = function() { return window.innerWidth <= 768; };

  function styleOverlay(modal) {
    var s = modal.style;
    s.setProperty('position', 'fixed', 'important');
    s.setProperty('top', '0', 'important');
    s.setProperty('left', '0', 'important');
    s.setProperty('right', '0', 'important');
    s.setProperty('bottom', '0', 'important');
    s.setProperty('width', '100vw', 'important');
    s.setProperty('height', '100vh', 'important');
    s.setProperty('background-color', 'rgba(0, 0, 0, 0.92)', 'important');
    s.setProperty('backdrop-filter', 'blur(8px)', 'important');
    s.setProperty('z-index', '999999', 'important');
    s.setProperty('display', 'flex', 'important');
    s.setProperty('align-items', 'center', 'important');
    s.setProperty('justify-content', 'center', 'important');
    s.setProperty('padding', '0', 'important');
    s.setProperty('margin', '0', 'important');
    s.setProperty('border', 'none', 'important');
    s.setProperty('outline', 'none', 'important');
    s.setProperty('box-shadow', 'none', 'important');
    // Remove any transform that would break fixed positioning of children
    s.setProperty('transform', 'none', 'important');
  }

  function collapseWrappers(modal, contentEl) {
    // Make ALL elements between overlay and content use display:contents
    // This makes them invisible to layout - content becomes a direct flex child
    var children = modal.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      var cls = (child.className && typeof child.className === 'string') ? child.className : '';

      // Skip close button
      if (cls.indexOf('quickViewClose') !== -1 || child.tagName === 'BUTTON') continue;

      // If this IS the content, skip
      if (child === contentEl) continue;

      // If this CONTAINS the content, make it display:contents and recurse
      if (contentEl && child.contains(contentEl)) {
        child.style.setProperty('display', 'contents', 'important');
        child.style.setProperty('background', 'transparent', 'important');
        child.style.setProperty('background-color', 'transparent', 'important');
        child.style.setProperty('border', 'none', 'important');
        child.style.setProperty('box-shadow', 'none', 'important');
        child.style.setProperty('outline', 'none', 'important');
        // Recurse into this wrapper
        collapseWrappers(child, contentEl);
      } else {
        // Random sibling div - hide backgrounds
        child.style.setProperty('background', 'transparent', 'important');
        child.style.setProperty('background-color', 'transparent', 'important');
        child.style.setProperty('border', 'none', 'important');
        child.style.setProperty('box-shadow', 'none', 'important');
      }
    }
  }

  function styleContent(content) {
    var s = content.style;
    var mobile = isMobile();

    // Common
    s.setProperty('background-color', '#1c1c1c', 'important');
    s.setProperty('background', '#1c1c1c', 'important');
    s.setProperty('border', 'none', 'important');
    s.setProperty('outline', 'none', 'important');
    s.setProperty('overflow-x', 'hidden', 'important');
    // Reset any app positioning - let flex handle centering
    s.setProperty('position', 'static', 'important');
    s.setProperty('top', 'unset', 'important');
    s.setProperty('left', 'unset', 'important');
    s.setProperty('right', 'unset', 'important');
    s.setProperty('bottom', 'unset', 'important');
    s.setProperty('transform', 'none', 'important');
    s.setProperty('margin', '0', 'important');
    s.setProperty('float', 'none', 'important');

    if (mobile) {
      s.setProperty('width', '100vw', 'important');
      s.setProperty('max-width', '100vw', 'important');
      s.setProperty('height', '100vh', 'important');
      s.setProperty('max-height', '100vh', 'important');
      s.setProperty('border-radius', '0', 'important');
      s.setProperty('box-shadow', 'none', 'important');
      s.setProperty('display', 'flex', 'important');
      s.setProperty('flex-direction', 'column', 'important');
      s.setProperty('overflow-y', 'auto', 'important');
    } else {
      s.setProperty('max-width', '920px', 'important');
      s.setProperty('width', 'calc(100% - 80px)', 'important');
      s.setProperty('max-height', 'calc(100vh - 80px)', 'important');
      s.setProperty('height', 'auto', 'important');
      s.setProperty('border-radius', '16px', 'important');
      s.setProperty('box-shadow', '0 30px 100px rgba(0, 0, 0, 0.5)', 'important');
      s.setProperty('display', 'flex', 'important');
      s.setProperty('flex-direction', 'row', 'important');
      s.setProperty('overflow-y', 'auto', 'important');
      // Flex item alignment
      s.setProperty('flex-shrink', '0', 'important');
      s.setProperty('align-self', 'center', 'important');
    }
  }

  function styleInternals(content) {
    var mobile = isMobile();

    // Details section
    var details = content.querySelector('[class*="quickViewDetails"]');
    if (details) {
      details.style.setProperty('background-color', '#1c1c1c', 'important');
      details.style.setProperty('background', '#1c1c1c', 'important');
      details.style.setProperty('border-left', 'none', 'important');
      details.style.setProperty('border-top', 'none', 'important');
      if (mobile) {
        details.style.setProperty('flex', '1 1 auto', 'important');
        details.style.setProperty('min-height', '0', 'important');
        details.style.setProperty('overflow-y', 'auto', 'important');
        details.style.setProperty('padding', '20px 16px 40px', 'important');
      }
    }

    // Images section
    var images = content.querySelector('[class*="quickViewImages"]');
    if (images) {
      images.style.setProperty('background-color', '#1c1c1c', 'important');
      images.style.setProperty('background', '#1c1c1c', 'important');
      if (mobile) {
        images.style.setProperty('flex', '0 0 auto', 'important');
        images.style.setProperty('max-width', '100%', 'important');
        images.style.setProperty('width', '100%', 'important');
        images.style.setProperty('padding', '50px 16px 16px', 'important');
      }
    }
  }

  function processModal(modal) {
    if (!modal) return;

    var content = modal.querySelector('[class*="quickViewContent"]');

    styleOverlay(modal);

    if (content) {
      // Collapse any wrapper divs between overlay and content
      collapseWrappers(modal, content);
      styleContent(content);
      styleInternals(content);
    }
  }

  // Debounce to avoid infinite loops from style observer
  var processing = false;
  function safeProcess(modal) {
    if (processing) return;
    processing = true;
    processModal(modal);
    setTimeout(function() { processing = false; }, 50);
  }

  // MutationObserver watches for modal appearing
  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        var target = mutation.target;
        var cn = target.className;
        if (cn && typeof cn === 'string' && cn.indexOf('quickViewModalVisible') !== -1) {
          safeProcess(target);
          setTimeout(function() { safeProcess(target); }, 100);
          setTimeout(function() { safeProcess(target); }, 300);
          setTimeout(function() { safeProcess(target); }, 600);
          setTimeout(function() { safeProcess(target); }, 1200);
        }
      }

      if (mutation.addedNodes && mutation.addedNodes.length) {
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (node.nodeType !== 1) continue;
          var ncn = node.className;
          if (ncn && typeof ncn === 'string' && ncn.indexOf('quickViewModal') !== -1) {
            (function(n) {
              setTimeout(function() { safeProcess(n); }, 100);
              setTimeout(function() { safeProcess(n); }, 500);
            })(node);
          }
          if (node.querySelectorAll) {
            var modals = node.querySelectorAll('[class*="quickViewModal"]');
            for (var k = 0; k < modals.length; k++) {
              (function(m) {
                setTimeout(function() { safeProcess(m); }, 100);
                setTimeout(function() { safeProcess(m); }, 500);
              })(modals[k]);
            }
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  // Watch for the app re-setting inline styles on content
  var styleObs = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (!t) continue;
      var cn = (t.className && typeof t.className === 'string') ? t.className : '';
      if (cn.indexOf('quickViewContent') !== -1 || cn.indexOf('quickViewModal') !== -1) {
        var modal = cn.indexOf('quickViewModal') !== -1 ? t : t.closest('[class*="quickViewModal"]');
        if (modal) safeProcess(modal);
      }
    }
  });

  styleObs.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['style']
  });

  // Check existing modals on load
  document.querySelectorAll('[class*="quickViewModalVisible"]').forEach(function(m) {
    processModal(m);
  });

  // =============================================
  // Product Card Quantity Selectors & Variant Buttons
  // Kill inline border-color set by Kitenzo app
  // =============================================
  function stripProductCardBorders() {
    // Quantity selectors
    document.querySelectorAll('[class*="productCardQuantitySelector"]').forEach(function(el) {
      el.style.setProperty('border', 'none', 'important');
      el.style.setProperty('border-width', '0', 'important');
      el.style.setProperty('border-color', 'transparent', 'important');
    });
    // Variant buttons
    document.querySelectorAll('[class*="variantButton"]').forEach(function(el) {
      // Don't kill border on selected buttons if we want a subtle indicator
      el.style.setProperty('border', 'none', 'important');
      el.style.setProperty('border-color', 'transparent', 'important');
    });
  }

  // Run on load and after DOM settles
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      stripProductCardBorders();
      setTimeout(stripProductCardBorders, 500);
      setTimeout(stripProductCardBorders, 1500);
      setTimeout(stripProductCardBorders, 3000);
    });
  } else {
    stripProductCardBorders();
    setTimeout(stripProductCardBorders, 500);
    setTimeout(stripProductCardBorders, 1500);
    setTimeout(stripProductCardBorders, 3000);
  }

  // Re-strip borders when new product cards are added to the DOM (childList only, no style watching)
  var cardObserver = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        stripProductCardBorders();
        break;
      }
    }
  });

  cardObserver.observe(document.body, {
    subtree: true,
    childList: true
  });
})();
